import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { DEBUG_MIN_VERSION } from '../../constants.ts';

export function DebugTooOld() {
  return (
    <div className="center flex-col gap-8 height-100">
      <p className="h5 mb-16">Client version {DEBUG_MIN_VERSION} required to debug</p>

      <LinkButton variant="secondary" to="/downloads" relative="path">
        Download update
      </LinkButton>
    </div>
  );
}
